import styled from 'styled-components'
import { White, Red } from '../../assets/colors'

export const Box = styled.div`
    margin: 0.5% 2% 1% 2%;
    padding: 10px 30px;
    flex: 1;
    max-width: 1356px;
    background: ${White};
    border-radius: 15px;
`
export const Title = styled.div`
    font-size: 30px;
    color: ${Red};
    font-weight: bold;
    padding-top: 20px;
    padding-bottom: 15px;
    display: flex;
    justify-content: center;
`
export const Head = styled.div`
    margin: 15px 0;
`

export const Content = styled.div``

export const CardDiv = styled.div`
    flex: 1;
    margin: ${props => props.margin && '0px 30px'};
`

export const Cards = styled.div`
    display: flex;
`
